import Graph from 'graphology';
import ImportWorker from './import.worker';
var WorkerPool = /** @class */ (function () {
    function WorkerPool() {
    }
    WorkerPool.prototype.import = function (options, callback) {
        var worker = new ImportWorker();
        worker.onmessage = function (event) {
            worker.terminate();
            var _a = event.data, error = _a.error, result = _a.result;
            if (error)
                return callback(error);
            return callback(null, {
                graph: Graph.from(result.serializedGraph),
                model: result.model,
                options: options
            });
        };
        worker.postMessage(options);
    };
    return WorkerPool;
}());
var pool = new WorkerPool();
export default pool;
